import clsx from "clsx";
import type { PropsWithChildren } from "react";
import { getThemeClass, getThemeComponentGroup } from "@/src_new/shared/lib/themeComponentClasses";

type WrapperInputProps = PropsWithChildren<{
  label: string;
  error?: string;
  description?: string;
  className?: string;
  required?: boolean;
}>;

export function WrapperInput({
  label,
  error,
  description,
  className,
  children,
  required,
}: WrapperInputProps) {
  const inputClasses = getThemeComponentGroup("input");
  const formSectionClasses = getThemeComponentGroup("formSection");

  return (
    <div className={clsx("flex flex-col gap-2", className)}>
      <label
        className={clsx(
          "text-[12px] font-semibold",
          getThemeClass(formSectionClasses.labelColor || inputClasses.labelColor, "text-theme-text")
        )}
      >
        {label}
        {required ? <span className="ml-1 text-theme-danger">*</span> : null}
      </label>
      {children}
      {description ? (
        <p
          className={clsx(
            "text-xs",
            getThemeClass(formSectionClasses.helperTextColor, "text-theme-text-soft")
          )}
        >
          {description}
        </p>
      ) : null}
      {error ? (
        <p
          className={clsx(
            "text-xs",
            getThemeClass(
              formSectionClasses.errorTextColor || inputClasses.errorTextColor,
              "text-theme-danger-bright"
            )
          )}
        >
          {error}
        </p>
      ) : null}
    </div>
  );
}
